import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import { formatDate } from "../../../utils/date_formatter";
import { BaseLandingCard } from "../BaseLandingCard";
import { DocumentExpiryLandingCardProps } from "./types";

export const DocumentExpiryLandingCard: React.FC<DocumentExpiryLandingCardProps> = ({
  profileName,
  dueDate,
  onContinue,
  onSkip,
  isLoading = false,
}) => {
  return (
    <BaseLandingCard
      illustrationName="document-required"
      title={`${profileName}'s document expired`}
      description={
        <>
          One or more of {profileName}&apos;s documents have expired and need to be updated.
          Please update all expired documents by {formatDate(dueDate)}.
        </>
      }
      onContinue={onContinue}
      onSkip={onSkip}
      isLoading={isLoading}
      skipModalConfig={{
        title: "Warning",
        body: (
          <Flex flexDirection="column" gap={Sizes.SM}>
            <Text variant="regular-md">
              If you skip now, you can return to this workflow using the link in your email to
              complete this submission.
            </Text>
            <Text variant="regular-md">
              <strong>Please note:</strong>
              <br />
              This must be completed by {formatDate(dueDate)} in order to receive distributions.
            </Text>
          </Flex>
        ),
        cancelButtonText: "Cancel",
        confirmButtonText: "Continue to skip",
      }}
    />
  );
};
